import { LocalGeoJsonObject } from "@iventis/map-types";
import { ModelPerformanceData } from "./model-testing-constants";

/** Given an array of coorindates create local GeoJson objects to put in the store */
export const createLocalObjects = (layerId: string, coords: [number, number][], level: number): LocalGeoJsonObject[] =>
    coords.map((coor, index) => ({
        feature: {
            geometry: { type: "Point", coordinates: coor },
            properties: { layerid: layerId, id: index.toString(), name: `object-${index.toString()}`, rotation: { x: 0, y: 0, z: 0 }, level },
            type: "Feature",
        },
        objectId: index.toString(),
        waypoints: [],
    }));

/** Places the models evenly around the origin */
export const calculateModelPlacement = (amountOfModels: number, origin: [number, number], factor = 0.001) => {
    const amountOfModelsPerEdge = Math.sqrt(amountOfModels);
    const halfAmountOfModelsPerEdge = amountOfModelsPerEdge / 2;
    const coords: [number, number][] = [];

    for (let x = -halfAmountOfModelsPerEdge; x <= halfAmountOfModelsPerEdge - 1; x += 1) {
        for (let y = -halfAmountOfModelsPerEdge; y <= halfAmountOfModelsPerEdge - 1; y += 1) {
            coords.push([origin[0] + x * factor, origin[1] + y * (factor * 2)]);
        }
    }

    return coords;
};

/** Create an CSV file with model performance results in */
export const downloadResults = (results: ModelPerformanceData[]) => {
    if (results.length !== 0) {
        // Create data
        const headers = ["Id", "Test Number", "Amount of Models", "Average FPS", "Below 30 FPS (%)", "Below 20 FPS (%)", "Below 10 FPS (%)"];
        const values = results.map((res) => Object.values(res));
        const rows = [headers, ...values];
        // Create CSV string
        const csvContent = `data:text/csv;charset=utf-8,${rows.map((e) => e.join(",")).join("\n")}`;
        const encodedUri = encodeURI(csvContent);
        // Create element to download CSV file
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", `model_performance_testing_${new Date().toISOString().split("T")[0]}.csv`);
        document.body.appendChild(link);
        link.click();
    }
};
